import ExpiredTrialPaywall from "@/features/paywall/components/expired-trial-paywall";
import FreeTrialPaywall from "@/features/paywall/components/free-trial-paywall";
import { isSoftPaywallAtom } from "@/stores/paywall.store";
import { useAtomValue } from "jotai";

export default function PaywallPage() {
  const isSoftPaywall = useAtomValue(isSoftPaywallAtom);

  return isSoftPaywall ? <FreeTrialPaywall /> : <ExpiredTrialPaywall />;
}
